<template>
<div>
	<div class="row">

		<div class="col-12">
			<partial-loader :loading="isFetching"></partial-loader>
		</div>

		<div class="col-12"
		     v-if="!isFetching">

			<b-alert v-if="error"
			         variant="danger"
			         show>{{ error }}</b-alert>

			<b-jumbotron class="mb-3 p-4">
				<div class="row">
					<div class="col">

						<h1 class="display-3">Veiling activiteit</h1>

						<div v-if="person">
							<person-info :person="person"></person-info>
						</div>
					</div>

					<div class="col-1">
						<b-button-group class="pull-right">
							<b-button :to="goBack()"
							          exact
							          v-b-tooltip.hover
							          title="Terug"
							          variant="outline-secondary"><i class="fa fa-fw fa-reply"></i></b-button>
						</b-button-group>
					</div>
				</div>
			</b-jumbotron>

		</div>
	</div>

	<div class="row mb-3">

		<div class="col-lg-12 col-xl-6">
			<b-jumbotron class="mb-3 p-4 h-100">
				<seller-cost></seller-cost>
			</b-jumbotron>
		</div>

		<div class="col-lg-12 col-xl-6">
			<b-jumbotron class="mb-3 p-4 h-100">
				<item-list></item-list>
			</b-jumbotron>
		</div>

	</div>

</div>
</template>

<script>
import { isNil } from 'lodash';
import PersonService from '@/services/person-service';
import BidService from '@/services/bid-service';
import AuctionService from '@/services/auction-service';
import PartialLoader from '@/components/elements/PartialLoader';
import SellerCost from './SellerCost';
import PersonInfo from '@/components/views/Person/PersonInfo';
import ItemList from './ItemList';
import { isCancel, CancelToken } from 'axios';
import { smallDate } from '@/filters/date-filters';

export default {
	components: {
		PartialLoader,
		SellerCost,
		ItemList,
		PersonInfo
	},
	filters: {
		smallDate
	},
	data() {
		return {
			isFetching: false,
			person: false,
			auctionBidNumbers: false,
			error: false
		}
	},
	methods: {
		fetchPerson() {
			this.isFetching = true;
			return PersonService.getOne(this.$route.params.personId).then(response => {
				this.isFetching = false;
				this.person = response;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		},
		goBack() {
			if (!isNil(this.$route.query.back)) {
				return { name: this.$route.query.back };
			} else {
				return { name: 'auction' };
			}
		}
	},
	mounted() {
		this.fetchPerson();
	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Seller.vue?4308ec69